interface ConfirmDialogProps {
    title: string;
    message: string;
    confirmLabel?: string;
    cancelLabel?: string;
    danger?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

/**
 * Generic confirm/cancel modal, styled to match this codebase's other
 * dialogs (ImportExportDialog.tsx, LocalizationDialog.tsx): plain
 * Bootstrap/Tabler modal classes, backdrop click cancels.
 */
export function ConfirmDialog({
    title,
    message,
    confirmLabel = 'Confirm',
    cancelLabel = 'Cancel',
    danger = false,
    onConfirm,
    onCancel,
}: ConfirmDialogProps) {
    return (
        <div
            className="modal d-block"
            style={{ background: 'rgba(0,0,0,0.5)', zIndex: 1050 }}
            onClick={(e) => e.target === e.currentTarget && onCancel()}
        >
            <div className="modal-dialog modal-dialog-centered modal-sm">
                <div className="modal-content">
                    <div className="modal-body text-center py-4">
                        <h3>{title}</h3>
                        <div className="text-muted">{message}</div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn w-100" onClick={onCancel}>
                            {cancelLabel}
                        </button>
                        <button
                            type="button"
                            className={`btn w-100 ${danger ? 'btn-danger' : 'btn-primary'}`}
                            onClick={onConfirm}
                        >
                            {confirmLabel}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
